import sleep from '@anm/helpers/sleep';
import { PageParams } from '@anm/hooks/usePageParams';
import Routes from 'next-routes';

type ChangeFiltersProps = {
  routes: Routes;
  params: PageParams;
  isQuery?: boolean;
  routeName?: string;
};

const waitForPreviousFinished = () => sleep(0);

const changeRouter = async ({ params, routes, routeName = 'video-template', isQuery = true }: ChangeFiltersProps) => {
  const { Router } = routes;
  const routerParams = {
    ...(isQuery && { ...Router.query }),
    ...params
  };

  await waitForPreviousFinished();

  Router.pushRoute(routeName, routerParams);
};

export default changeRouter;
